export default __webpack_public_path__ + "static/media/whatsapp-button.2fd29fff.svg";